import { getWebSocket, registerWebSocket } from './session';

const waitForSocketReady = (socket: WebSocket): Promise<void> => {
  if (socket.readyState === WebSocket.OPEN) {
    return Promise.resolve();
  }

  if (socket.readyState !== WebSocket.CONNECTING) {
    return Promise.reject(new Error('WebSocket is not available'));
  }

  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error('Timed out waiting for WebSocket connection'));
    }, 5000);

    const cleanup = () => {
      clearTimeout(timeout);
      socket.removeEventListener('open', handleOpen);
      socket.removeEventListener('error', handleError);
    };

    const handleOpen = () => {
      cleanup();
      resolve();
    };

    const handleError = () => {
      cleanup();
      reject(new Error('WebSocket connection failed'));
    };

    socket.addEventListener('open', handleOpen, { once: true });
    socket.addEventListener('error', handleError, { once: true });
  });
};

const needsRegistration = (socket: WebSocket | null) =>
  !socket ||
  socket.readyState === WebSocket.CLOSING ||
  socket.readyState === WebSocket.CLOSED;

export const sendWebSocketPing = async (
  userID: string,
  organizationID?: string
): Promise<void> => {
  if (!userID) return;

  let socket = getWebSocket();

  if (needsRegistration(socket)) {
    socket = await registerWebSocket(userID, organizationID);
  }

  if (!socket) {
    throw new Error('Unable to establish WebSocket connection for ping');
  }

  await waitForSocketReady(socket);

  socket.send(
    JSON.stringify({
      action: 'ping',
      userID,
      timestamp: Date.now(),
    })
  );
};
